<script lang="ts" setup>
import { useContactTimelineFilterStore, useFilterStore } from '@/stores';
import { CallType } from '@/types';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const filterStore = useFilterStore();
const timelineStore = useContactTimelineFilterStore();

const dateRange = computed<Array<Date>>({
    get: () => filterStore.dateRange,
    set: (range) => filterStore.setDateRange(range),
});

const callTypeFilterOptions = [
    { label: t(`call.type.${CallType.INBOUND}`), value: CallType.INBOUND },
    { label: t(`call.type.${CallType.OUTBOUND}`), value: CallType.OUTBOUND },
    { label: t(`call.type.${CallType.INTERNAL}`), value: CallType.INTERNAL },
];

const sentimentFilterOptions = [
    { label: t('contact.filters.sentiment.satisfied'), value: 'positive' },
    { label: t('contact.filters.sentiment.neutral'), value: 'neutral' },
    { label: t('contact.filters.sentiment.unsatisfied'), value: 'negative' },
];
</script>

<template>
    <div class="grid grid-cols-3 gap-4 text-xs">
        <UiDatePicker v-model="dateRange" range multiCalendars />
        <UiMultiselect
            name="filters_type"
            v-model="timelineStore.callType"
            :options="callTypeFilterOptions"
            :placeholder="t('contact.filters.allCallTypes')"
            class="[&_.multiselect]:!h-[36px]"
            can-clear
        />
        <UiMultiselect
            name="filters_sentiment"
            v-model="timelineStore.sentiment"
            :options="sentimentFilterOptions"
            :placeholder="t('contact.filters.allSentiments')"
            class="[&_.multiselect]:!h-[36px]"
            can-clear
        />
    </div>
</template>
